import styled from 'styled-components';
import { Icon } from '@perch-labs/shrike';
import { Container } from 'styles';

export const Circle = styled.div`
  height: 8px;
  width: 8px;
  border-radius: 50%;
  background-color: ${props => props.theme.colors.content.accent4};
  position: absolute;
  top: 6px;
  left: -28px;

  ${props => props.theme.media.small`
  left: -24px
`}
`;

export const ParentContainer = styled(Container)`
  position: relative;
`;

export const StyledIcon = styled(Icon).attrs({
  icon: 'ExclamationCircleInverted',
})`
  position: absolute;
  top: 2px;
  left: -32px;

  ${props => props.theme.media.small`
    left: -28px
  `}
`;
